import PageHeader from "Components/Pages/Header";
import PageWrapper from "Components/Pages/Wrapper";
import Breadcrumb from "Components/Shared/Breadcrumb";
import { Form, FormikProvider } from "formik";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { Store } from "Reducers/interface";
import validatePermissions from "Utils/validatePermissions";
import { LoadingText } from "Components/LoadingText";
import { Box } from "styles/globalComponents";
import { FormUnit } from "../components/Form";
import { useUnit } from "../useUnit";

export const EditUnit = () => {
  const user_permissions = useSelector(
    (state: Store) => state.User.permissions
  );
  const history = useHistory();
  const { id: params_id } = useParams<{ id: string }>();
  const { formik, isLoading, hasData } = useUnit(params_id);

  return (
    <PageWrapper className="entry-app-content">
      <div className="content-holder ">
        <div className="page-heading">
          <div className="wrapper-header-content">
            <PageHeader title="Editar unidade">
              <Breadcrumb
                list={[
                  {
                    path: "/unidades",
                    label: "Unidades",
                    current: false,
                  },
                  {
                    path: "#",
                    label: "Editar unidade",
                    current: true,
                  },
                ]}
              />
            </PageHeader>

            {hasData ? (
              <div className="actions-holder">
                {validatePermissions("Create Units", user_permissions) && (
                  <div className="actions-holder">
                    <button
                      type="button"
                      className="link link-danger"
                      onClick={() => history.push("/unidades")}
                    >
                      Voltar
                    </button>
                    <button
                      type="submit"
                      onClick={() => formik.handleSubmit()}
                      className="button _action"
                      disabled={false}
                    >
                      Editar
                    </button>
                  </div>
                )}
              </div>
            ) : null}
          </div>
        </div>

        {isLoading ? <LoadingText text="Carregando dados da unidade" /> : null}

        {hasData && (
          <FormikProvider value={formik}>
            <Form>
              <FormUnit unitId={params_id || null} />
            </Form>
          </FormikProvider>
        )}

        {!hasData && !isLoading && (
          <Box mt="62">
            <p className="text-center text-purple" style={{ fontSize: "24px" }}>
              Unidade nao encontrada
            </p>
          </Box>
        )}
      </div>
    </PageWrapper>
  );
};
